module.exports = __webpack_public_path__ + "img/banner.abdc0c2b.jpg";